import createReactComponent from '../createReactComponent';
export default createReactComponent('plus-equal', 'IconPlusEqual', [
  ['path', { d: 'M4 7h6', key: 'svg-0' }],
  ['path', { d: 'M7 4v6', key: 'svg-1' }],
  ['path', { d: 'M20 16h-6', key: 'svg-2' }],
  ['path', { d: 'M20 19h-6', key: 'svg-3' }],
  ['path', { d: 'M5 19l14 -14', key: 'svg-4' }],
]);
